import { Link } from "raviger";
import { useTranslation } from "react-i18next";

import { EyeIcon, PencilIcon } from "@heroicons/react/24/outline";

import { Button } from "@/components/ui/button";

interface ActionButtonsProps {
  editPath?: string;
  viewPath: string;
}

export function ActionButtons({ editPath, viewPath }: ActionButtonsProps) {
  const { t } = useTranslation();

  return (
    <>
      <Button variant="outline" size="sm" asChild className="w-19 h-9 lg:h-8">
        <Link basePath="/" href={viewPath}>
          <EyeIcon className="size-5 text-xl" />
          {t("view")}
        </Link>
      </Button>
      {editPath && (
        <Button variant="outline" size="sm" asChild className="w-19 h-9 lg:h-8">
          <Link basePath="/" href={editPath}>
            <PencilIcon className="size-5 text-sm" />
            {t("edit")}
          </Link>
        </Button>
      )}
    </>
  );
}
